import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import Collapse from '@material-ui/core/Collapse';

import { Paper, PopOut } from 'components'
import { FaChevronDown, FaChevronUp } from 'react-icons/fa'
import Options from './Options'

import classes from './Dropdown.module.css'

const defaultStyle = {
    backgroundColor: 'var(--secondary-color)',
    padding: '0.5rem 1rem',
    optionPadding: '0.5rem 1rem',
    fontSize: '0.9rem',
    placement: 'bottom',
    width: '8rem',
    minWidth: null
}

const Container = styled.div`
    width: ${props => props.width || '8rem'};
    margin: ${props => props.margin};
    min-width: ${props => props.minWidth};
    box-shadow: var(--box-shadow);
    border-radius: 5px;
`

const SelectDropdown = styled.div`
    box-sizing: border-box;
    cursor: pointer;
    color: var(--text-color);
    outline: none;
    font-weight: ${props => props.styles.fontWeight};
    font-size: ${props => props.styles.fontSize};
    padding: ${props => props.styles.padding};
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    /* width: ${props => props.styles.width || '8rem'}; */
    vertical-align: middle;
    border-radius: 5px;
    background-color: ${props => props.styles.backgroundColor};
    max-width: ${props => props.styles.maxWidth};
    border: ${props => props.styles.border};
    :hover {
        filter: brightness(var(--brightness));
    }
`
const Dropdown = props => {
    const {
        options,
        value,
        onSelect,
        onOpen,
        style,
        placeholder,
        error
    } = props;
    let updatedStyle = Object.assign({}, defaultStyle, style)
    updatedStyle['margin'] = 0
    const [open, setOpen] = useState(false)
    const [width, setWidth] = useState(style && style['width'])
    const [selected, setSelected] = useState(value || placeholder)
    const ref = React.createRef()
    useEffect(() => {
        value && setSelected(value)
    }, [value])

    useEffect(() => {
        setWidth(ref.current.getBoundingClientRect()['width'])
    }, [])

    // Handlers
    const onSelectHandler = (val) => {
        setSelected(options[val])
        onSelect(val)
    }

    const onOpenHandler = (event) => {
        event.preventDefault()
        setOpen(!open)
        onOpen && onOpen()
    }

    updatedStyle['width'] = `${width}px`
    return (
        <Container width={updatedStyle['width']} minWidth={updatedStyle['minWidth']} error={error} margin={style && style.margin} contenteditable={false} 
            onClick={onOpenHandler}>
            <PopOut trigger='leftClick' placement={updatedStyle['placement']}  animation='dropdown'
                element={<Options styles={(({ fontWeight, border, ...o }) => o)(updatedStyle)} options={options} onSelectHandler={onSelectHandler}/>}>
                <SelectDropdown styles={updatedStyle} ref={ref}>
                    <div className={classes.Text}>{value || selected}</div>
                    <div className={classes.Icon}>{open ? <FaChevronUp/> : <FaChevronDown/>}</div>
                </SelectDropdown>
            </PopOut>
        </Container>
    )
}

export default Dropdown

Dropdown.propTypes = {
    options: PropTypes.object,
    value: PropTypes.string,
    onSelect: PropTypes.func,
}